import { render, staticRenderFns } from "./ThuxListComponent.vue?vue&type=template&id=2e05808a&"
import script from "./ThuxListComponent.vue?vue&type=script&lang=js&"
export * from "./ThuxListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports